import React, { useContext, useEffect } from 'react';
import { AppContext } from 'contexts/AppContext';
import { redirectToFusionAuthLogin } from 'services/fusionAuthService';
import LoadingScreen from 'components/Molecules/LoadingScreen';

const FusionAuthLogin = () => {
  const { organizationId, propertyId, marketingInfo } = useContext(AppContext);

  useEffect(() => {
    const heroImageURL = marketingInfo?.propertyLogoLink?.length
      ? marketingInfo.propertyLogoLink
      : marketingInfo?.propertyInfo?.propertyLogoLink;
    if (organizationId?.length && propertyId?.length && heroImageURL) {
      return redirectToFusionAuthLogin({
        organizationId,
        propertyId,
        heroImageURL,
        backgroundImageURL: marketingInfo?.propertyPhotoLinks[0],
      });
    }
    return () => {};
  }, [organizationId, propertyId, marketingInfo]);

  return <LoadingScreen message="Welcome to Portal" />;
};

export default FusionAuthLogin;
